var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolicy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8425\u9500\u7B56\u7565-\u672A\u9009@4x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0903\\u4FEE\\u6539",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    transform: "translate(-225.000000, -640.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-24",
    transform: "translate(199.000000, 343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4\\u5907\\u4EFD-6",
    transform: "translate(10.000000, 286.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8425\\u9500\\u7B56\\u7565-\\u672A\\u9009",
    transform: "translate(16.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,10 L17,10 C17.5522847,10 18,10.4477153 18,11 L18,16 C18,17.1045695 17.1045695,18 16,18 L4,18 C2.8954305,18 2,17.1045695 2,16 L2,11 C2,10.4477153 2.44771525,10 3,10 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-2",
    fill: "#B5B5C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,4 L18,4 C18.5522847,4 19,4.44771525 19,5 L19,10 C19,11.1045695 18.1045695,12 17,12 L3,12 C1.8954305,12 1,11.1045695 1,10 L1,5 C1,4.44771525 1.44771525,4 2,4 Z",
    id: "\\u77E9\\u5F62",
    fill: "#E9E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF",
    x: 8,
    y: 9,
    width: 4,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,4 L7,3 C7,2.44771525 7.44771525,2 8,2 L12,2 C12.5522847,2 13,2.44771525 13,3 L13,4 L13,4",
    id: "\\u8DEF\\u5F84-3",
    stroke: "#B5B5C3",
    strokeWidth: 2
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/policy.552cc296.svg";
export { ForwardRef as ReactComponent };